// src/hooks/use-organization-features.ts
import { useQuery } from '@tanstack/react-query'
import { useAuth0 } from '@auth0/auth0-react'
import { useOrgStore } from '@/stores/orgStore'

interface Feature {
    id: string
    name: string
    label: string
    icon: string
    path: string
}

export const useOrganizationFeatures = () => {
    const { getAccessTokenSilently } = useAuth0()
    const { currentOrgId } = useOrgStore()
    const apiUrl = import.meta.env.VITE_API_URL

    return useQuery<Feature[]>({
        queryKey: ['organizationFeatures', currentOrgId, apiUrl],
        queryFn: async () => {
            if (!currentOrgId) throw new Error('No organization selected')

            const accessToken = await getAccessTokenSilently()
            const response = await fetch(
                `${apiUrl}/organizations/${currentOrgId}/features`,
                {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            )
            if (!response.ok) throw new Error('Failed to fetch features')
            return response.json()
        },
        enabled: !!currentOrgId,
    })
}
